/* eslint-disable max-len */
import { useMemo, useState, useEffect, useContext } from "react";
import styled, { css } from "styled-components";
import axios from "axios";
import { useScreenClass } from "react-grid-system";
import { useHistory, useLocation } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { Col, Row } from "../../components/StyledGridSystem";
import QuickAccessIcon, {
  QuickAccessContainer,
} from "../../components/QuickAccessIcon";
import _theme from "../../styles/theme";
import FlexBox from "../../components/FlexBox";
import { CourseContent, EmptyCourseContent } from "../../filter/FilterValue";
import EnrollCourse from "../../components/EnrollCourse";
import { StudentContext } from "../../context/StudentBehalfContext";
import SnackBar from "../../components/SnackBar";
import MinimalSelect from "../../components/MinimalSelect";
import { UserContext } from "../../context/UserContext";

interface report {
  report: any;
  term: string;
}

const RightAlign = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Greytext = styled.div`
  color: ${({ theme }) => theme.color.textSecondary}!important;
  white-space: nowrap;
`;

function MyCoursesPage() {
  const test = [
    { name: "Courses", link: "/courses/" },
    { name: "My Courses", link: "/courses/history" },
  ];

  const sharedMinimalStyle = css`
    min-width: 200px;
    border-color: hsl(0, 0%, 80%);
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    padding: 0px 12px;
    .react-select__menu {
      text-align: left;
      width: 100%;
      min-width: unset;
      margin-left: -12px;
    }
  `;

  const StyledMinimalSelect = styled(MinimalSelect)`
    ${sharedMinimalStyle}
  `;

  const screenClass = useScreenClass();
  const isMobile = useMemo(() => ["xs", "sm"].includes(screenClass), [
    screenClass,
  ]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currCourse, setCurrCourse] = useState<report>({
    report: [],
    term: "",
  });
  const [stages, setStages] = useState({
    addend: false,
    dropnoW: false,
    dropwithW: false,
  });
  const [isNotified, setIsNotified] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [snackOpen, setSnackOpen] = useState(false);

  const [currentTerms, setCurrentTerms] = useState([
    {
      id: 0,
      name: "",
    },
  ]);
  const { student } = useContext(StudentContext);
  const [studentProgram, setStudentProgram] = useState<string>("");
  const [currentCourses, setCurrentCourses] = useState<CourseContent[]>([
    EmptyCourseContent,
  ]);
  const [activeSemester, setActiveSemester] = useState<string[]>([]);
  const [activeTerm, setActiveTerm] = useState<any>({});
  const { isBehalf } = useContext(StudentContext);
  const studentBehalf = useContext(StudentContext);
  const currentUser = useContext(UserContext).user;

  // const handleDropCourse = (regId: string) => {
  //   // alert(`/api/v1/grading/dropCourse?course_reg_id=${regId}`);
  //   axios.post(`/api/v1/grading/dropCourse?course_reg_id=${regId}`);
  //   setIsModalOpen(false);
  //   window.location.reload(false);
  // };

  // <-------- fetch data ---------->

  const [programOption, setProgramOption] = useState([
    { label: "", value: "" },
  ]);

  // const [selectedProgram, setSelectedProgram] = useState<{
  //   label: string;
  //   value: string;
  // }>({ label: "", value: "" });

  // const selectedProgram = useMemo(() => {
  //   const item = localStorage.getItem("selectedProgram");
  //   return item ? JSON.parse(item) : { label: "", value: "" };
  // }, [localStorage.getItem("selectedProgram")]);

  const [selectedProgram, setSelectedProgram] = useState<{
    label: string;
    value: string;
  }>(() => {
    const item = localStorage.getItem("selectedProgram");
    return item ? JSON.parse(item) : { label: "", value: "" };
  });

  useEffect(() => {
    // fetchCurrentTerms();
    activeSemester.length === 0 && fetchActiveSemester();
    if (isBehalf) {
      fetchUserInfo(studentBehalf.student.student_id);
      if (selectedProgram && selectedProgram.value) {
        fetchCourses(studentBehalf.student.student_id, selectedProgram.value);
      }
    } else {
      fetchUserInfo(currentUser.student_id);
      if (selectedProgram && selectedProgram.value) {
        fetchCourses(currentUser.student_id, selectedProgram.value);
      }
    }
  }, [student, selectedProgram, localStorage.getItem("selectedProgram")]);

  const location = useLocation<{ message?: string , showSnack?: boolean}>();
  const history = useHistory();

  useEffect(() => {
    const msg = location.state?.message;
    const show = location.state?.showSnack;
    if (msg) setMessage(msg);
    if (show) setSnackOpen(true);
    // clear so refresh/back won't re-show
    if (location.state) history.replace({ ...history.location, state: undefined });
  }, [location, history]);

  const fetchCourses = async (student_id: string, program_id: string) => {
    setCurrentTerms([]);
    if (program_id) {
      setLoading(true);
      axios
        .get(
          `/api/v1/students/courses?student_id=${student_id}&program_id=${program_id}`
        )
        .then((res) => {
          setCurrentCourses(res.data.data.courses);

          const termOrder = ["Fall", "Summer", "Spring"];

          // Extract unique terms from courses
          const uniqueTerms: any = Array.from(
            new Map(
              res.data.data.courses
                .filter(
                  (course: any) =>
                    course.term && course.term.id && course.term.name
                )
                .map((course: any) => [
                  course.term.id,
                  { id: course.term.id, name: course.term.name },
                ])
            ).values()
          ).sort((a: any, b: any) => {
            // Extract year and season from term name, e.g., "Fall 2025"
            const [seasonA, yearA] = a.name.split(" ");
            const [seasonB, yearB] = b.name.split(" ");

            // Sort by year descending
            if (yearA !== yearB) {
              return Number(yearB) - Number(yearA);
            }
            // If same year, sort by season order
            return termOrder.indexOf(seasonA) - termOrder.indexOf(seasonB);
          });
          setCurrentTerms(uniqueTerms);

          setLoading(false);
        })
        .catch(() => {});
    }
  };

  const fetchActiveSemester = () => {
    axios.get("/api/v1/courses/terms/current").then((res) => {
      if (res.data.data) {
        setActiveSemester(res.data.data.terms?.map((term: any) => term.name));
        setActiveTerm(res.data.data.terms[0]);
      }
    });
  };

  const fetchCurrentTerms = () => {
    setLoading(true);
    axios
      .get(`/api/v1/students/${student.student_id}/courses/semesters`)
      .then((res) => {
        if (res.data.data) {
          setIsNotified(true);
          setCurrentTerms(res.data.data.terms);
          if (res.data.data.terms[0]) {
            setStages({
              addend: res.data.data.terms[0].add_course_end,
              dropnoW: res.data.data.terms[0].drop_course_without_w_end,
              dropwithW: res.data.data.terms[0].drop_course_end,
            });
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const fetchCalendar = () => {
    axios
      .get("/api/v1/document/academic_calendar")
      .then((res) => {
        const link = document.createElement("a");
        link.href = res.data.data.document.url;
        link.setAttribute("download", res.data.data.document.file_name);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        if (error.response) {
          setMessage(
            error.response.data.error.message || "Failed to create competency!"
          );
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };

  const fetchUserInfo = (id: string) => {
    setLoading(true);
    axios
      .get(`/api/v1/students/${id}`)
      .then((res) => {
        // setProgramId(res.data.data.program.id);

        const tempPrograms: Array<{ label: string; value: string }> = [];
        !selectedProgram.value &&
          setSelectedProgram({
            label:
              res.data.data.programs[0].short_name +
              " (" +
              res.data.data.programs[0].activity_type_name +
              ")",
            value: res.data.data.programs[0].program_id,
          });

        !localStorage.getItem("selectedProgram") &&
          localStorage.setItem(
            "selectedProgram",
            JSON.stringify({
              label:
                res.data.data.programs[0].short_name +
                " (" +
                res.data.data.programs[0].activity_type_name +
                ")",
              value: res.data.data.programs[0].program_id,
            })
          );

        res.data.data.programs.map(
          (program: {
            program_id: string;
            short_name: string;
            activity_type_name: string;
          }) =>
            tempPrograms.push({
              label:
                program.short_name + " (" + program?.activity_type_name + ")",
              value: program.program_id,
            })
        );
        setProgramOption(tempPrograms);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        message={message}
        type="error"
      />
      <SnackBar
        isOpen={snackOpen}
        setOpen={setSnackOpen}
        message={message}
        type="success"
      />
      <Row>
        <Col>
          <Breadcrumb path={test} />
        </Col>
        <Col style={{ textAlign: "end" }}>
          <StyledMinimalSelect
            value={programOption.find(
              (data) => data.value === selectedProgram.value
            )}
            onChange={(data: { label: string; value: string }) => {
              setSelectedProgram(data);
              localStorage.setItem("selectedProgram", JSON.stringify(data));
            }}
            options={
              programOption.sort((a: any, b: any) =>
                a.label?.localeCompare(b.label)
              ) || []
            }
          />
        </Col>
      </Row>
      <Row justify="between">
        <Col>
          <FlexBox>
            <h2>My Courses</h2>
            <div style={{ marginLeft: "auto" }}>
              <Greytext>
                <RightAlign>Current Semester</RightAlign>
              </Greytext>
              {/* {console.log(currCourse.term)} */}
              <RightAlign style={{ fontWeight: "bold" }}>
                {/* {currentTerms &&
                  currentTerms.length > 0 &&
                  (currentTerms[0].name || "N/A")} */}
                {activeSemester && activeSemester}
              </RightAlign>
            </div>
          </FlexBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <QuickAccessContainer isMobile={isMobile}>
            <QuickAccessIcon to="/courses/courseCatalog" icon="note-text">
              Courses Catalog
            </QuickAccessIcon>
            <QuickAccessIcon
              onClick={() => fetchCalendar()}
              to="/courses/myCourses"
              icon="calendar-dates"
            >
              Academic Calendar
            </QuickAccessIcon>
            {/* <QuickAccessIcon to="/courses" icon="bookmark-add"><>Summer/<wbr/>Fall&nbsp;2021 Registration</></QuickAccessIcon> */}
            {/* <QuickAccessIcon to="/courses" icon="bookmark-add">
              <><span dangerouslySetInnerHTML={{ __html: nextsem.nsemester.replace(' ', '&nbsp;').replace('/', isMobile ? '/<wbr/>' : '/') }} /> Registration</>
            </QuickAccessIcon> */}
            <QuickAccessIcon to="/courses/history" icon="time-history">
              Enrollment History
            </QuickAccessIcon>
          </QuickAccessContainer>
        </Col>
      </Row>
      {!loading ? (
        <>
          {!currentTerms.some((term) => activeSemester.includes(term.name)) && (
            <EnrollCourse
              currentCourses={currentCourses}
              activeSemester={activeSemester}
              termID={activeTerm.id || ""}
              termName={activeTerm.name || ""}
              term={{
                ...activeTerm,
                name: activeTerm.name,
                add_course_start: activeTerm.add_course_start,
                // add_course_end: activeTerm.add_course_end,
                course_add_deadline: activeTerm.course_add_deadline,
                course_drop_deadline: activeTerm.course_drop_deadline,
                is_course_add_valid: activeTerm.is_course_add_valid,
                is_course_drop_valid: activeTerm.is_course_drop_valid,
              }}
              program={selectedProgram}
              fetchParent={() =>
                isBehalf
                  ? fetchCourses(
                      studentBehalf.student.student_id,
                      selectedProgram.value
                    )
                  : fetchCourses(currentUser.student_id, selectedProgram.value)
              }
            />
          )}
          {currentTerms?.map((term) => {
            const fullTerm = currentCourses
              .map((course) => course.term)
              .find((t) => t && t.id === term.id) || {
              ...term,
              add_course_start: undefined,
              // add_course_end: undefined,
              course_add_deadline: undefined,
              course_drop_deadline: undefined,
              is_course_add_valid: false,
              is_course_drop_valid: false,
            };

            return (
              <EnrollCourse
                currentCourses={currentCourses}
                activeSemester={activeSemester}
                termID={String(term.id)}
                termName={term.name}
                term={fullTerm}
                program={selectedProgram}
                fetchParent={() =>
                  isBehalf
                    ? fetchCourses(
                        studentBehalf.student.student_id,
                        selectedProgram.value
                      )
                    : fetchCourses(
                        currentUser.student_id,
                        selectedProgram.value
                      )
                }
              />
            );
          })}
        </>
      ) : (
        <></>
      )}
      {/* <EnrollCourse term='name'/> */}
    </>
  );
}
export default MyCoursesPage;
